import { IRoleListTableLang } from '../../../types/lang'

export const roleListTableLang: IRoleListTableLang = {
	role_list_table: {
		column_id: 'ID',
		column_code: 'Code',
		column_name: 'Name',
		column_is_buyer: 'Buyer',
		column_in_group: 'Group',
		column_is_team: 'Team',
		column_team_report: 'Team Report',
		column_permissions: 'Permissions',
		column_is_system: 'System',
		column_access: 'Access'
	}
}